import { CustomReplace } from 'roosterjs-editor-plugins/lib/CustomReplace';
import type { CustomReplacement } from 'roosterjs-editor-types';
import { isFeatureEnabled } from 'owa-feature-flags';

function makeEmojiReplacement(sourceString: string, replacementHTML: string): CustomReplacement {
    return {
        sourceString: sourceString,
        replacementHTML: replacementHTML,
        matchSourceCaseSensitive: true,
    };
}

function makeOrdinalNumbersReplecement(
    sourceString: string,
    replacementHTML: string
): CustomReplacement {
    return {
        sourceString: sourceString,
        replacementHTML: replacementHTML,
        matchSourceCaseSensitive: true,
        shouldReplace: shouldReplaceOrdinalNumber,
    };
}

function shouldReplaceOrdinalNumber(replacement: CustomReplacement, content: string): boolean {
    const { sourceString } = replacement;
    const charBefore = content[content.length - sourceString.length - 1];
    if (
        (sourceString === 'st ' && charBefore === '1') ||
        (sourceString === 'nd ' && charBefore === '2') ||
        (sourceString === 'rd ' && charBefore === '3') ||
        (sourceString === 'th ' && (parseInt(charBefore) > 3 || parseInt(charBefore) === 0))
    ) {
        return true;
    } else {
        return false;
    }
}

// Used by CustomEdit, and handles autocomplete for emoji shortcuts beginning with a non-colon
// EmojiPickerPlugin handleEventExclusively when the inline emoji popup is shown
// and handles shortcut completion for all emoji which begin with a colon
const emojiReplacements: CustomReplacement[] = [
    makeEmojiReplacement(';)', '😉'),
    makeEmojiReplacement(';-)', '😉'),
    makeEmojiReplacement(';P', '😜'),
    makeEmojiReplacement(';-P', '😜'),
    makeEmojiReplacement('<3', '❤️'),
    makeEmojiReplacement('</3', '💔'),
    makeEmojiReplacement(';*', '😘'),
    makeEmojiReplacement(';-*', '😘'),
    makeEmojiReplacement('B)', '😎'),
    makeEmojiReplacement('B-)', '😎'),
];

const ordinalNumberReplacement: CustomReplacement[] = [
    makeOrdinalNumbersReplecement('st ', '<sup>st</sup>&nbsp;'),
    makeOrdinalNumbersReplecement('nd ', '<sup>nd</sup>&nbsp;'),
    makeOrdinalNumbersReplecement('rd ', '<sup>rd</sup>&nbsp;'),
    makeOrdinalNumbersReplecement('th ', '<sup>th</sup>&nbsp;'),
];

export default class OwaCustomReplace extends CustomReplace {
    constructor() {
        super(
            isFeatureEnabled('cmp-auto-super-script')
                ? [...emojiReplacements, ...ordinalNumberReplacement]
                : emojiReplacements
        );
    }
}
